(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doma-experience"] && !Shopify.designMode) return;
  try {
    
  const note=new URLSearchParams(location.search).get('nota');
  if(/^[1-5]$/.test(note||'')){
    const option=document.querySelector('#DomaExperience input[name="contact[Nota]"][value="'+note+'"]');
    if(option)option.checked=true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      if ('ResizeObserver' in window) {
        this.domaHeaderResize = new ResizeObserver(() => this.setHeaderHeight());
        this.domaHeaderResize.observe(this);
      }

      this.onHeaderResize = this.setHeaderHeight.bind(this);
      if (!this.domaHeaderResize) window.addEventListener('resize', this.onHeaderResize, {passive: true});

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          if (this.isConnected) this.onScroll();
        });
      };
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, {passive: true});

      this.createObserver();
    }

    setHeaderHeight() {
      const outerHeight = this.offsetHeight;
      const headerInner = this.querySelector('.header');
      const headerHeight = this.hasAttribute('data-doma-navigation-enabled') ? outerHeight : (headerInner ? headerInner.offsetHeight : outerHeight);
      if (this.dataset.domaCompact === 'true' && this.parentElement) {
        const reservedHeight = `${outerHeight}px`;
        if (this.parentElement.style.height !== reservedHeight) this.parentElement.style.height = reservedHeight;
      }
      const measuredHeight = `${headerHeight}px`;
      if (document.documentElement.style.getPropertyValue('--header-height') !== measuredHeight) {
        document.documentElement.style.setProperty('--header-height', measuredHeight);
      }
      if (document.body.style.paddingTop !== '0px') document.body.style.paddingTop = '0px';
    }

    disconnectedCallback() {
      if (this.domaHeaderResize) this.domaHeaderResize.disconnect();
      if (this.headerIntersection) this.headerIntersection.disconnect();
      window.removeEventListener('resize', this.onHeaderResize);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = 0;
      window.clearTimeout(this.isScrolling);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      this.headerIntersection = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerIntersection.observe(this);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.headerIsAlwaysSticky) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.headerIsAlwaysSticky) return;
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      this.toggleScrolledClass();
    }

    toggleScrolledClass() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrolled = scrollTop > 50; // Adiciona a classe após rolar 50px
      if (this.header.classList.contains('scrolled-past-header') !== scrolled) {
        this.header.classList.toggle('scrolled-past-header', scrolled);
        if (!this.domaHeaderResize) this.setHeaderHeight();
      }
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
  
// Script para ativar o Mega Menu no hover em desktop
document.addEventListener('DOMContentLoaded', () => {
  const desktopMediaQuery = window.matchMedia('(min-width: 990px)');

  function handleMegaMenuHover(detailsElement) {
    const summaryElement = detailsElement.querySelector('summary.header__menu-item');
    const contentElement = detailsElement.querySelector('.mega-menu__content');
    let openTimeout;
    let closeTimeout;
    const delay = 150; 

    detailsElement.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      if (desktopMediaQuery.matches && !detailsElement.hasAttribute('open')) {
        openTimeout = setTimeout(() => {
          detailsElement.setAttribute('open', '');
        }, delay);
      }
    });

    detailsElement.addEventListener('mouseleave', () => {
      clearTimeout(openTimeout); 
      if (desktopMediaQuery.matches && detailsElement.hasAttribute('open')) {
        closeTimeout = setTimeout(() => {
          detailsElement.removeAttribute('open');
        }, delay);
      }
    });

    summaryElement.addEventListener('focusin', () => {
      clearTimeout(closeTimeout); 
      if (desktopMediaQuery.matches && !detailsElement.hasAttribute('open')) {
        detailsElement.setAttribute('open', '');
      }
    });

    detailsElement.addEventListener('focusout', (event) => {
      requestAnimationFrame(() => {
        if (desktopMediaQuery.matches && detailsElement.hasAttribute('open') && !detailsElement.contains(document.activeElement)) {
          detailsElement.removeAttribute('open');
        }
      });
    });
  }

  document.querySelectorAll('[data-mega-menu-desktop]').forEach(details => {
    handleMegaMenuHover(details);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison-slider"] && !Shopify.designMode) return;
  try {
    
class ImageComparison {
  constructor(element) {
    this.element = element;
    this.clippedImage = this.element.querySelector('.image-comparison__clipped-image');
    this.handle = this.element.querySelector('.image-comparison__handle');
    this.images = this.element.querySelectorAll('.image-comparison__image');
    this.isDragging = false;
    this.currentPosition = 50;
    this.init();
    this.setPosition(this.currentPosition);
  }

  init() {
    this.handle.addEventListener('mousedown', this.startDragging.bind(this));
    window.addEventListener('mousemove', this.onDrag.bind(this));
    window.addEventListener('mouseup', this.stopDragging.bind(this));
    window.addEventListener('mouseleave', this.stopDragging.bind(this));

    this.handle.addEventListener('touchstart', this.startDragging.bind(this), { passive: false });
    window.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
    window.addEventListener('touchend', this.stopDragging.bind(this));

    this.images.forEach(img => {
      img.addEventListener('dragstart', e => e.preventDefault());
    });

    this.element.addEventListener('click', this.onClick.bind(this));
  }

  getPositionFromEvent(event) {
    const rect = this.element.getBoundingClientRect();
    const pageX = event.type.includes('touch') ? event.touches[0].pageX : event.pageX;
    const x = pageX - rect.left - window.scrollX;
    const position = (x / rect.width) * 100;
    return Math.max(0, Math.min(100, position));
  }

  setPosition(position) {
    this.currentPosition = position;
    requestAnimationFrame(() => {
      this.clippedImage.style.width = `${position}%`;
      this.handle.style.left = `${position}%`;
    });
  }

  startDragging(event) {
    if (event.type.includes('mouse')) {
      event.preventDefault();
    }
    this.isDragging = true;
    this.element.classList.add('dragging');
    document.body.style.cursor = 'col-resize';
  }

  stopDragging() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.element.classList.remove('dragging');
    document.body.style.cursor = '';
  }

  onDrag(event) {
    if (!this.isDragging) return;
    event.preventDefault();
    const position = this.getPositionFromEvent(event);
    this.setPosition(position);
  }
  
  onClick(event) {
    if (event.target.closest('.image-comparison__handle-button')) {
      return;
    }
    const position = this.getPositionFromEvent(event);
    this.setPosition(position);
  }
}

function initializeImageComparisons() {
  const elements = document.querySelectorAll('[data-image-comparison]');
  elements.forEach(element => {
    if (!element.imageComparisonInstance) {
      element.imageComparisonInstance = new ImageComparison(element);
    }
  });
}

// Inicializa em diferentes eventos para garantir o funcionamento
document.addEventListener('DOMContentLoaded', initializeImageComparisons);
document.addEventListener('shopify:section:load', initializeImageComparisons);

// Inicializa caso já esteja tudo carregado
if (document.readyState === 'complete') {
  initializeImageComparisons();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
(() => {
  const root = document.getElementById('product-tabs-{{ section.id }}');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  root.classList.add('is-enhanced');

  const tabs = Array.from(root.querySelectorAll('[data-tab]'));
  const allowed = new Set(tabs.map(t => t.dataset.tab));

  function setActive(target) {
    if (!allowed.has(target) || root.dataset.active === target) return;
    root.dataset.active = target;
    tabs.forEach(t => {
      const on = t.dataset.tab === target;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => setActive(tab.dataset.tab));
    tab.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const i = tabs.indexOf(tab);
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus();
        setActive(next.dataset.tab);
      }
    });
  });

  let startX = 0, startY = 0, tracking = false;
  root.addEventListener('touchstart', e => {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    tracking = true;
  }, { passive: true });

  root.addEventListener('touchend', e => {
    if (!tracking) return;
    tracking = false;
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    const cur = root.dataset.active;
    if (dx < 0 && cur === 'description') setActive('reviews');
    else if (dx > 0 && cur === 'reviews') setActive('description');
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  let instances = {};

  class TimelineSlider {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.slidesContainer = this.container.querySelector('.timeline-slides-container');
      this.slides = this.container.querySelectorAll('.timeline-slide');
      this.years = this.container.querySelectorAll('.timeline-year');
      this.nextButton = this.container.querySelector('.slider-button--next');
      this.prevButton = this.container.querySelector('.slider-button--prev');
      this.navWrapper = this.container.querySelector('.timeline-slider-navigation');
      this.highlightBar = this.container.querySelector('.timeline-highlight-bar');

      if (this.slides.length < 2) return;
      
      this.currentIndex = 0;
      this.autoplay = this.container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed, 10);
      const transitionSpeed = this.container.dataset.transitionSpeed;
      this.container.style.setProperty('--transition-speed', transitionSpeed);

      this.init();
    }

    init() {
      this.navWrapper.style.display = 'block';
      this.bindEvents();
      this.updateSlider();
      if (this.autoplay) this.startAutoplay();
      
      this.resizeObserver = new ResizeObserver(() => this.updateHighlightBar());
      this.resizeObserver.observe(this.container);
    }

    bindEvents() {
      // Usar .bind(this) para manter a referência da função e poder removê-la depois
      this.next = this.next.bind(this);
      this.prev = this.prev.bind(this);
      this.goTo = this.goTo.bind(this);
      
      this.nextButton.addEventListener('click', this.next);
      this.prevButton.addEventListener('click', this.prev);
      
      this.yearClick = (e) => {
        const index = parseInt(e.currentTarget.dataset.yearIndex, 10);
        this.goTo(index);
      };
      this.years.forEach(year => year.addEventListener('click', this.yearClick));

      if (this.autoplay) {
        this.startAutoplay = this.startAutoplay.bind(this);
        this.stopAutoplay = this.stopAutoplay.bind(this);
        this.container.addEventListener('mouseenter', this.stopAutoplay);
        this.container.addEventListener('mouseleave', this.startAutoplay);
      }

      let touchstartX = 0;
      this.touchStartHandler = (e) => {
        touchstartX = e.changedTouches[0].screenX;
        if (this.autoplay) this.stopAutoplay();
      };
      this.touchEndHandler = (e) => {
        const touchendX = e.changedTouches[0].screenX;
        this.handleSwipe(touchstartX, touchendX);
        if (this.autoplay) this.startAutoplay();
      };
      this.slidesContainer.addEventListener('touchstart', this.touchStartHandler, { passive: true });
      this.slidesContainer.addEventListener('touchend', this.touchEndHandler, { passive: true });
    }
    
    destroy() {
      this.stopAutoplay();
      if (this.resizeObserver) this.resizeObserver.disconnect();

      this.nextButton.removeEventListener('click', this.next);
      this.prevButton.removeEventListener('click', this.prev);
      this.years.forEach(year => year.removeEventListener('click', this.yearClick));
      this.slidesContainer.removeEventListener('touchstart', this.touchStartHandler);
      this.slidesContainer.removeEventListener('touchend', this.touchEndHandler);
      
      if (this.autoplay) {
        this.container.removeEventListener('mouseenter', this.stopAutoplay);
        this.container.removeEventListener('mouseleave', this.startAutoplay);
      }
    }

    handleSwipe(start, end) {
      const threshold = 50;
      if (end < start - threshold) this.next();
      if (end > start + threshold) this.prev();
    }

    goTo(index) {
      if (index < 0) this.currentIndex = this.slides.length - 1;
      else if (index >= this.slides.length) this.currentIndex = 0;
      else this.currentIndex = index;
      this.updateSlider();
    }

    next() { this.goTo(this.currentIndex + 1); }
    prev() { this.goTo(this.currentIndex - 1); }

    updateSlider() {
      this.slidesContainer.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.currentIndex));
      this.years.forEach((y, i) => y.classList.toggle('is-active', i === this.currentIndex));
      this.updateHighlightBar();
    }

    updateHighlightBar() {
      if (!this.highlightBar || this.years.length < 1) return;

      const currentYear = this.years[this.currentIndex];
      const nextYear = this.years[this.currentIndex + 1];

      const startPos = currentYear.offsetLeft;
      let newWidth = 0;

      if (nextYear) {
        newWidth = nextYear.offsetLeft - startPos;
      } else {
        newWidth = currentYear.parentElement.offsetWidth - startPos;
      }
      
      this.highlightBar.style.left = `${startPos}px`;
      this.highlightBar.style.width = `${newWidth}px`;
    }

    startAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    }
  }

  function initSlider(container) {
    if (!container) return;
    const sectionId = container.dataset.sectionId;
    // Limpa a instância anterior se ela existir
    if (instances[sectionId]) {
      instances[sectionId].destroy();
    }
    // Cria e armazena a nova instância
    instances[sectionId] = new TimelineSlider(container);
  }

  function destroySlider(container) {
    if (!container) return;
    const sectionId = container.dataset.sectionId;
    if (instances[sectionId]) {
      instances[sectionId].destroy();
      delete instances[sectionId];
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.timeline-slider-section').forEach(section => initSlider(section));
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section && section.classList.contains('timeline-slider-section')) {
      initSlider(section);
    }
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (section && section.classList.contains('timeline-slider-section')) {
      destroySlider(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
